import {useDispatch, useSelector} from "react-redux";
import ModalBody from "../../../core/Modal/ModalBody/ModalBody";
import Button from "../../../core/Button/Button";
import React from "react";
import {closeLobbyModal} from "../../../redux/actions/lobby/actions";
import {useTranslation} from "react-i18next";

function ServerInfoModal() {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {msg, details} = useSelector(state => state.lobby.server);
    const goDepositPage = () => {
        window.parent.postMessage({action: 'goDeposit'}, '*')
    }
    const isCardError = details?.redirect && details.errorType === 'card_blocked';
    return <>
        <ModalBody>
            <div className="server-info-modal">
                <p>{t(`server.${msg}`)}</p>
                <div className="server-info-modal__buttons">
                    {
                        isCardError && <Button
                            onClick={() => goDepositPage()}
                            type={"green"}
                            text={t("modals.buttons.deposit")}
                        />
                    }
                    <Button
                        onClick={() => dispatch(closeLobbyModal())}
                        type={"yellow"}
                        text={t("modals.buttons.ok")}
                    />
                </div>
            </div>
        </ModalBody>
    </>

}

export default ServerInfoModal